module.exports = __webpack_public_path__ + "static/media/externalBarn_15.ff67eddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_15.png
// module id = 1303
// module chunks = 3